import { arrayOf, shape, string } from 'prop-types';
import React from 'react';
import {
  Select,
  SelectFieldDescription,
  SelectFieldTitle,
  SelectSpacing,
  SelectWrapper,
} from './styles';

function SelectField({ description, id, option, title, value, ...rest }) {
  return (
    <SelectSpacing>
      {Boolean(title) && <SelectFieldTitle>{title}</SelectFieldTitle>}
      {Boolean(description) && (
        <SelectFieldDescription>{description}</SelectFieldDescription>
      )}
      <SelectWrapper>
        <Select id={id} value={value || 'null'} {...rest}>
          <option value="null" disabled>
            Välj en adress
          </option>
          {option.map(({ address }, i) => (
            <option key={address} value={i === 0 ? 'ONE' : 'TWO'}>
              {address}
            </option>
          ))}
        </Select>
      </SelectWrapper>
    </SelectSpacing>
  );
}

SelectField.propTypes = {
  description: string,
  id: string.isRequired,
  option: arrayOf(
    shape({
      address: string,
      apporvalStatus: string,
      landlord: string,
      postalCode: string,
    })
  ).isRequired,
  title: string,
  value: string,
};

SelectField.defaultProps = {
  description: '',
  title: '',
  value: 'null',
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/SelectField/SelectField.js